import { zodResolver } from '@hookform/resolvers/zod';
import { useCreateBookmarkByUrlSchema } from '@metto/ui-web/domains/bookmarks';
import { useForm } from 'react-hook-form';
import type * as z from 'zod';

export const useCreateBookmarkByUrlForm = () => {
  const schema = useCreateBookmarkByUrlSchema();

  return useForm({
    resolver: zodResolver(schema),
    mode: 'onSubmit',
    delayError: 100 // Prevent submit button shifting under cursor
  });
};

export type CreateBookmarkByUrlFormData = z.infer<
  ReturnType<typeof useCreateBookmarkByUrlSchema>
>;
